import { put } from 'redux-saga/effects';
import * as actions from '@/store/actions';
import { apiClient } from '@/utils';
import { AxiosResponse } from 'axios';

export function* errorCheck() {
    try {
        const response: AxiosResponse = yield apiClient.get('/settings/errorcheck');

        console.log('Error Check Response:', response.data);

        yield put(actions.FETCH_ERROR_CHECK.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_ERROR_CHECK.failure(error));
    }
}
